import _objectSpread from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import productApiService from "../../services/api/ProductApiService";
import Loader from "../../components/Loader.vue";
import LoadingButton from "../../components/loading-button/LoadingButton.vue";
export default {
  name: "SettingItem",
  components: {
    Loader: Loader,
    LoadingButton: LoadingButton
  },
  data: function data() {
    return {
      loading: false,
      updated: false,
      inputTypes: ["integer", "string"],
      checkboxTypes: ["boolean"]
    };
  },
  computed: _objectSpread({}, mapGetters({
    currentProvider: "profile/currentProvider"
  })),
  methods: {
    save: function save(value) {
      var _this = this;

      this.loading = true;
      this.updated = false;
      productApiService.storeOrEditShopSettings(this.item.id, value !== null && value !== void 0 ? value : this.item.value, this.currentProvider.id).then(function (result) {
        _this.$vs.notify({
          text: result.message,
          color: "success",
          position: "bottom-center"
        });
      }).finally(function () {
        _this.loading = false;
        _this.updated = true;
      });
    }
  },
  watch: {
    "item.value": function itemValue(newValue) {
      if (typeof newValue === "boolean") {
        this.save(newValue);
      }
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};